module.exports = __webpack_public_path__ + "static/media/reactlogo.63b7a228.png";